module.exports = __webpack_public_path__ + "static/based-segmentation-4-1182847fbdb18dc9f75b861c8ad8cf36.png";